// `/app/splits/authorizations` (WEB-123, `19` §4.1): aba "Autorizações" da tela de Splits. A
// rota-pai desenha o cabeçalho e as abas e põe este `<Outlet/>` no painel.
//
// Autorização não tem `mode`: as queries não levam o modo na key e trocar Produção/Teste não
// muda nada aqui (a tela diz isso).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { ReceiptText } from 'lucide-react';
import {
  createSplitAuthorization,
  givenAuthorizationsQueryOptions,
  grantedAuthorizationsQueryOptions,
  revokeSplitAuthorization,
  splitAuthorizationsKeys,
} from '../api/queries/splits.ts';
import { AuthorizationsPanel } from '../features/splits/authorizations-panel.tsx';
import { PiaoLink } from '../features/splits/links.tsx';

function Authorizations() {
  const queryClient = useQueryClient();
  const given = useQuery(givenAuthorizationsQueryOptions());
  const granted = useQuery(grantedAuthorizationsQueryOptions());

  const invalidate = () => queryClient.invalidateQueries({ queryKey: splitAuthorizationsKeys.all });

  const create = useMutation({
    mutationFn: createSplitAuthorization,
    onSuccess: invalidate,
  });
  const revoke = useMutation({
    mutationFn: revokeSplitAuthorization,
    onSuccess: invalidate,
  });

  return (
    <AuthorizationsPanel
      given={{
        data: given.data,
        isLoading: given.isPending,
        error: given.error,
        onRetry: () => {
          void given.refetch();
        },
      }}
      granted={{
        data: granted.data,
        isLoading: granted.isPending,
        error: granted.error,
        onRetry: () => {
          void granted.refetch();
        },
      }}
      onAuthorize={async (email) => {
        await create.mutateAsync(email);
      }}
      onRevoke={async (id) => {
        await revoke.mutateAsync(id);
      }}
      newChargeLink={<PiaoLink to="/app/transactions" label="Nova cobrança" icon={ReceiptText} />}
    />
  );
}

export const Route = createFileRoute('/app/splits/authorizations')({ component: Authorizations });
